module.exports = __webpack_public_path__ + "img/group2_2x.5aba45d7.png";